import React, { useContext, useEffect, useState } from "react";
import UserContext from "../../contexts/UserContext";
import Utils from "../../Utils";
import _ from "lodash";

const HrHeader = (props) => {
  const { logout, userData } = useContext(UserContext);
  const [open, setOpen] = useState(false);

  const LogOut = (e) => {
    e.preventDefault();
    logout(() => {
      window.location.href = process.env.PUBLIC_URL + "/";
    });
  };

  return (
    <>
    <header class="bg-white shadow-md py-4 px-8 flex justify-between items-center header">
        <div class="text-2xl font-bold text-gray-800"><img src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="Marriott Bonvoy" class="logo" /></div>
        <nav>
            <ul class="flex space-x-6">
                <li><a href={`${process.env.PUBLIC_URL}/hotel-representative-dashboard`} class="text-gray-600 hover:text-blue-500">Dashboard</a></li>
                <li><a href={`${process.env.PUBLIC_URL}/hotel-representative-manage-photoshoots`} class="text-gray-600 hover:text-blue-500">Photoshoots</a></li>
                <li><a href="#" onClick={LogOut} class="text-gray-600 hover:text-blue-500">Logout</a></li>
            </ul>
        </nav>
    </header>
    </>
  );
};

export default HrHeader;
